// DO NOT EDIT -- generated from fs/services/dx-objects/modeltypes.proto

export enum ObjectType {
  UNKNOWN = 0,
  METRIC = 1,
  FUNNEL = 2,
  RETENTION = 3,
  TEXT = 4,
  SEGMENT = 5,
  DASHBOARD = 6,
  HEATMAP = 7,
  JOURNEY = 8,
  ELEMENT = 9,
  EVENT = 10,
  API_EVENT = 14,
  /** PAGE already defined in VirtualDashboardId enum */
  PAGE_TYPE = 11,
  SPACE = 12,
  SPEC_OBJECT_MAPPING = 13,
  SPEC_PROPERTY_MAPPING = 17,
  PROPERTY = 15,
  DATA_TABLE = 16
}
